import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {ToastrModule} from 'ngx-toastr';
import { OverlayModule } from '@angular/cdk/overlay';

import { metaReducers, reducers } from './reducers';
import { NotFoundComponent } from './not-found/not-found.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideRouter } from '@angular/router';
import * as Sentry from "@sentry/angular";
import { routes } from './app-routing.module';


@NgModule({ declarations: [
        AppComponent,
        NotFoundComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        OverlayModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            closeButton: true,
            enableHtml: true,
            progressBar: true
        }),
        StoreModule.forRoot(reducers, {
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false,
            },
            metaReducers
        }),
        EffectsModule.forRoot([]),
        AppRoutingModule],
        providers: [
            provideRouter(routes),
            provideHttpClient(),

            // Register Sentry error handler
            { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },

            // Force Angular to instantiate TraceService (enables routing traces)
            Sentry.TraceService,
            provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({
                cookieName: 'csrftoken',
                headerName: 'X-CSRFToken',
            }))
        ] })
export class AppModule { }
